import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import { Box } from "grommet";

class MetricRow extends React.Component {
  render() {
    let { children } = this.props;

    if (!children) {
      return null;
    }

    if (!Array.isArray(children)) {
      children = [children];
    }

    const cells = children.map((child, i) => {
      return (
        <Box
          height="58px"
          width="metric-cell"
          justify="center"
          verticalAlign="middle"
          style={{ overflow: "visible" }}
          key={i}
        >
          {child}
        </Box>
      );
    });

    return (
      <Box direction="row">
        {cells}
      </Box>
    );
  }
}

MetricRow.propTypes = {
  children: PropTypes.any
};

export default observer(MetricRow);
